import { BranchInfoRoute } from '@shared/branchinfo/branchinfo.routes';
import { IModuleConfig, MenuKind } from '@simac/ui';

export const SharedModuleConfig: IModuleConfig = {
  name: 'Shared',
  routing: {
    menuKind: MenuKind.Main,
    route: 'branch',
    children: [
      {
        title: 'MENU.BRANCHINFO',
        route: BranchInfoRoute,
        permission: 'User.BranchInfo.View',
        icon: 'far fa-square-info',
      },
    ],
  },
  injects: [
    {
      name: 'admin',
      components: [
        {
          name: 'Hangfire',
          icon: 'far fa-fireplace',
          translateLabel: 'Hangfire',
          permission: '',
          externRoute: `${globalThis.location.origin}/hangfire`,
        },
        {
          name: 'Releasenotes',
          icon: 'far fa-notes',
          translateLabel: 'RELEASENOTES.COMPONENT',
          permission: '',
          pages: [
            {
              isDefault: true,
              route: 'releasenotes',
              loadComponent: () => import('../releasenotes/components/release.component').then((m) => m.AdminReleaseComponent),
            },
            {
              isDefault: false,
              route: 'releasenotes/:id',
              loadComponent: () => import('../releasenotes/components/notes.component').then((m) => m.AdminReleaseNotesComponent),
            },
          ],
        },
        {
          name: 'Project contact persons',
          icon: 'far fa-address-book',
          translateLabel: 'PROJECT-CONTACTPERSON.MANAGEMENT',
          permission: '',
          pages: [
            {
              isDefault: true,
              route: 'contactperson',
              loadComponent: () => import('../contactpersons/admin/pages/admin-contactperson.component').then((m) => m.AdminContactpersonComponent),
            },
          ],
        },
        {
          name: 'Contact mail history',
          icon: 'far fa-envelopes-bulk',
          translateLabel: 'PROJECT-CONTACTPERSON.MAILHISTORY',
          permission: '',
          pages: [
            {
              isDefault: true,
              route: 'contactperson-mailhistory',
              loadComponent: () => import('../contactpersons/admin/pages/admin-mailhistory.component').then((m) => m.AdminMailhistoryComponent),
            },
            {
              isDefault: false,
              route: 'contactperson-mailhistory/:id',
              loadComponent: () => import('../contactpersons/admin/pages/admin-mailhistory-details.component').then((m) => m.AdminMailhistoryDetailsComponent),
            },
          ],
        },
      ],
    },
    {
      name: 'projectmanagement',
      components: [
        {
          name: 'Contact person management',
          icon: 'far fa-address-book',
          translateLabel: 'PROJECT-CONTACTPERSON.MANAGEMENT',
          permission: 'App.ProjectManagement.ContactPerson.View',
          pages: [
            {
              isDefault: true,
              route: 'contactperson-management',
              loadComponent: () => import('../contactpersons/projectmanagement/pages/contactperson-management.component').then((m) => m.ContactpersonManagementComponent),
            },
          ],
        },
      ],
    },
  ],
};
